import { render, staticRenderFns } from "./AddExamScore.vue?vue&type=template&id=d51dea4c"
import script from "./AddExamScore.vue?vue&type=script&lang=js"
export * from "./AddExamScore.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports